export default __webpack_public_path__ + "static/media/account-active.8a041204.svg";